import { combineReducers } from 'redux';
import container from './container-reducers';
import {
  SET_ACTIVE_DEVICE,
  INSERT_ELEMENT_INTO_COLUMN,
  REMOVE,
} from '../actions/action-names';

function containerReducer(state, action) {
  return container(state, {
    ...action,
    highlightedId: state.present.highlightedId
  });
}

const activeDevice = (state = 'desktop', action) => {
  switch (action.type) {
    case SET_ACTIVE_DEVICE:
      return action.device;

    default:
      return state;
  }
};

const desktop = (state = {}, action) => {
  switch (action.type) {
    case INSERT_ELEMENT_INTO_COLUMN:
    case SET_ACTIVE_DEVICE:
      return container(state, {
        ...action,
        reducerForDevice: 'desktop'
      });
  }

  switch (action.device) {
    case 'desktop':
      return containerReducer(state, action);

    default:
      return state;
  }
};

const tablet = (state = {}, action) => {
  switch (action.type) {
    case INSERT_ELEMENT_INTO_COLUMN:
    case SET_ACTIVE_DEVICE:
      return container(state, {
        ...action,
        reducerForDevice: 'tablet'
      });
  }

  switch (action.device) {
    case 'tablet':
      return containerReducer(state, action);

    default:
      return state;
  }
};

const mobile = (state = {}, action) => {
  switch (action.type) {
    case INSERT_ELEMENT_INTO_COLUMN:
    case SET_ACTIVE_DEVICE:
      return container(state, {
        ...action,
        reducerForDevice: 'mobile'
      });
  }

  switch (action.device) {
    case 'mobile':
      return containerReducer(state, action);

    default:
      return state;
  }
};

export default combineReducers({
  activeDevice,
  desktop,
  tablet,
  mobile,
});



// WEBPACK FOOTER //
// ./app/header-builder/reducers/model-reducers.js